<template>
    <div
        :style="[modalOverride]"
        :class="['full-screen-modal', open && 'open', hidden && 'hidden', { topHeadingLayout: hasTopHeading }]"
        :id="name"
    >
        <div :style="[wrapperOverride]" class="inner-wrapper">
            <div v-if="hasTopHeading" class="top-heading">
                <slot name="topHeading"></slot>
            </div>
            <div class="close" @click="closeModal()">
                <button class="btn-close"></button>
            </div>

            <div class="container">
                <div class="row">
                    <div class="col">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>

        <div :class="['modal-overlay', { 'd-none': forceNoOverlay }]"></div>
    </div>
</template>

<script>
// lodash components
import some from 'lodash/some'
import split from 'lodash/split'

export default {
    props: {
        name: String,
        forceNoOverlay: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            open: false,
            hidden: true,
            topOffset: null,
            wrapperOverride: {},
            modalOverride: {},
            iframeAllowedSites: [],
        }
    },
    mounted() {
        this.iframeAllowedSites = this.themeSetting('iframe_allowed_sites')

        window.addEventListener(
            'message',
            event => {
                const messageContent = event.data

                if (some(this.iframeAllowedSites, ['name', event.origin])) {
                    const variables = split(messageContent, '|')
                    const modalOffset = variables[1]
                    const windowHeight = variables[2]
                    this.topOffset = `${modalOffset - 50}px`

                    this.wrapperOverride.height = `${windowHeight}px`
                    this.wrapperOverride.overflow = 'scroll'
                    this.wrapperOverride.position = 'fixed'
                    this.wrapperOverride.background = '#ffffff'
                    this.wrapperOverride.zIndex = '11'

                    this.modalOverride.padding = '0'
                    this.modalOverride.top = this.topOffset
                    this.modalOverride.position = 'fixed'
                }
            },
            false,
        )

        this.setupEventReceiver()
    },
    computed: {
        hasTopHeading: function () {
            return !!this.$slots['topHeading']
        },
    },
    methods: {
        closeModal: function () {
            this.emitter.emit(this.name, {
                open: false,
            })
        },
        setupEventReceiver() {
            this.emitter.on(this.name, payload => {
                if (payload.open) {
                    this.hidden = false

                    setTimeout(() => {
                        this.open = true
                        document.documentElement.scrollTop = 0
                        document.body.classList.add('overflow-hidden')
                    }, 100)
                } else {
                    this.open = false

                    // Add delay when hiding, fixes animation render bug
                    setTimeout(() => {
                        this.hidden = true
                        document.body.classList.remove('overflow-hidden')
                    }, 300)
                }
            })
        },
    },
    watch: {
        // mounted does not always run as Vue sometimes reuses components
        name() {
            this.setupEventReceiver()
        },
    },
}
</script>

<style lang="scss" scoped>
.modal-overlay {
    background: rgba(0, 0, 0, 0.6);
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
}
</style>
